import { Injectable, inject } from '@angular/core';
import { JssPlatformService } from '@core/jss-platform';
import type {
  ImageField,
  LinkField,
  RichTextField,
  TextField,
} from '@core/jss-proxy';

@Injectable({
  providedIn: 'root',
})
export class FieldService {
  readonly #jssPlatformService = inject(JssPlatformService);

  showImageField(imageField?: ImageField): boolean {
    return (
      this.isEditorActive() ||
      !!(imageField?.value?.src && imageField?.value['alt'])
    );
  }

  showLinkField(linkField?: LinkField | null): boolean {
    return (
      this.isEditorActive() ||
      !!(
        (linkField?.value?.anchor || linkField?.value?.href) &&
        linkField?.value?.text
      )
    );
  }

  showLinkFields(...linkFields: (LinkField | null | undefined)[]): boolean {
    return (
      this.isEditorActive() ||
      linkFields.some((field) => this.showLinkField(field))
    );
  }

  showTextField(textField?: TextField | RichTextField): boolean {
    return this.isEditorActive() || !!textField?.value;
  }

  private isEditorActive(): boolean {
    return this.#jssPlatformService.isEditorActive();
  }
}
